import React, { useState } from 'react';

import copy from 'copy-to-clipboard';

import './CopyClipboard.scss';

interface CopyClipboardProps {
  className?: string;
  content: string;
  durationInMs?: number;
}

export const CopyClipboard: React.FC<CopyClipboardProps> = ({
  content,
  className,
  durationInMs = 2000,
}) => {
  const [active, setActive] = useState<boolean>(false);

  const handleOnClick = (): void => {
    setActive(true);
    copy(content);
    setTimeout(() => {
      setActive(false);
    }, durationInMs);
  };
  const theme = document.body.classList.contains("dark") ? "dark" : "light";

  return (
    <span
      data-tooltip={'Copied!'}
      className={`tooltipClipboard clipboard ${active ? 'active' : ''} ${
        className ? className : ''
      }`}
      onClick={handleOnClick}
    >
      <img src={`/icons/copy-${theme}.svg`} alt="" width="28" height="auto" />
    </span>
  );
};
